export const GET_ALL_COMMUNITY_GEOGRAPHIES = "GET_ALL_COMMUNITY_GEOGRAPHIES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_COMMUNITY_GEOGRAPHIES = "START_LOADING_COMMUNITY_GEOGRAPHIES";
export const STOP_LOADING_COMMUNITY_GEOGRAPHIES = "STOP_LOADING_COMMUNITY_GEOGRAPHIES";
export const ERROR_LOADING_COMMUNITY_GEOGRAPHIES = "ERROR_LOADING_COMMUNITY_GEOGRAPHIES";
